import React, {Component} from 'react'

import styles from './Hint.less'

export default class Hint extends Component {
    render() {
        const {error, className, children, ...props} = this.props

        const classes = [styles['hint']]

        if (error) {
            classes.push(styles['hint_error'])
        }

        if (className) {
            classes.push(className)
        }

        return (
            <div className={classes.join(' ')} {...props}>{children}</div>
        )
    }
}
